// extracted by mini-css-extract-plugin
export default {"elementsWrapper":"ModalTableHeaders_elementsWrapper__AC7WJ","element":"ModalTableHeaders_element__8mYUD","active":"ModalTableHeaders_active__B8ItD"};